module.exports = __webpack_public_path__ + "img/code.8b561027.svg";